import axios from 'api';
import { fetchProquoteSettings } from './generalServices';

export const sendTrackingInfo = async (trackingData) => {
  trackingData.detail.txtProQuotePageNumber = `${sessionStorage.getItem('globalPageNumber')}`;
  try {
        const security = await fetchProquoteSettings();
        const body = {
          security,
          trackingObject: trackingData
        };

      //let res = await axios.post('/tracking/sendTrackingInfo', trackingData);
      let res = await axios.post('/tracking/sendTrackingInfoProQuote', body);
    } catch (error) {
      console.log(error);
  }
};

export const getTrackingInfo = async (userName) => {
  try {
    let res = await axios.get(`/tracking/getTrackingInfo/${userName}`);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getAllTrackingInfo = async () => {
  try {
    let res = await axios.get('/tracking/getAllTrackingInfo');
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
